var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"title",attrs:{"title":_vm.title}},[_vm._v("\n  "+_vm._s(_vm.document.subcorpus.toUpperCase())+" / "+_vm._s(_vm.document.language.substring(0, 2))+" / "+_vm._s(_vm.document.year)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }